import React, { Component } from 'react';
import { Query } from 'react-apollo';
import Loading from '../../components/loading/loading';
import HtmlParse from 'html-react-parser';
import { ANNOUNCE_VARIABLES, ANNOUNCE_QUERY } from '../../query/announce';
import { Helmet } from 'react-helmet';

class AnnouncePage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div className="static-page-container">
        <Query variables={ANNOUNCE_VARIABLES} query={ANNOUNCE_QUERY}>
          {({ data, loading, error }) => {
            if (loading || !data) {
              return <Loading />;
            } else if (error) console.error(error);
            else {
              return (
                <div className="announce-container">
                  <Helmet>
                    <title>{data.SuperContent.Title} - Radyo D</title>
                  </Helmet>
                  <h2>{data.SuperContent.Title}</h2>
                  {HtmlParse(data.SuperContent.Text)}
                </div>
              );
            }
          }}
        </Query>
      </div>
    );
  }
}

export default AnnouncePage;
